<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <div class="page-wrapper">
    <div class="content">
      <div class="page-header">
        <div class="add-item d-flex">
          <div class="page-title">
            <h4>Donation List</h4>
            <h6>Manage Donations</h6>
          </div>
        </div>
        <ul class="table-top-head">
          <!-- <li>
            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Refresh"
              ><i data-feather="rotate-ccw" class="feather-rotate-ccw"></i
            ></a>
          </li> -->
          <li>
            <a
              ref="collapseHeader"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Collapse"
              @click="toggleCollapse(collapseHeader)"
            >
              <i data-feather="chevron-up" class="feather-chevron-up"></i>
            </a>
          </li>
          <li>
            <a title="Refresh" @click="fetchDonations()"><i data-feather="rotate-ccw" class="feather-rotate-ccw"></i
            ></a>
          </li>
        </ul>
        <div class="page-btn"></div>
      </div>
      <!-- USER TABLE -->
      <filter-table
        :filter-by="filterBy"
        :extra-class="['table', 'datanew']"
        :columns="donations.columns"
        :data="donations.data"
        :filters="donations.filters"
        v-model:page-data="pageData"
      >
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'user'">
            <div class="userimgname gap-2 align-items-center">
              <a href="javascript:void(0);" class="userslist-img bg-img gap-2">
                <Avatar
                  :src="record.user.avatar"
                  :alt="record.user.name"
                  img-class="user-image"
                />
              </a>
              <div>
                <a href="javascript:void(0);">{{ record.user.name }}</a>
              </div>
            </div>
          </template>
          <template v-else-if="column.key === 'amount'">
            {{ formatAmount(record.amount, true) }}
          </template>

          <template v-else-if="column.key === 'campaign'">
            <template v-if="record.campaign">
              <a href="javascript:void(0);"
                   class="campaign-link"
                   @click="openModal(record.campaign)">
                <i data-feather="eye" class="feather-eye"></i>
                <span>Campaign</span>
              </a>
            </template>

            <template v-else>
              —
            </template>
          </template>

          <template v-else-if="column.key === 'status'">
            <span :class="getBadgeClass(record.status)">{{
              record.status
            }}</span>
          </template>

          <template v-else-if="column.key === 'created_at'">
            {{ formatDate(record.created_at) }}
          </template>
        </template>
      </filter-table>
      <!-- USER TABLE -->
    </div>
  </div>

  <CampaignModal :campaign="campaign"/>
</template>

<script setup>
import { computed, onMounted, ref, reactive } from "vue";
import { toggleCollapse } from "@/utils/components";
import Avatar from "@/components/avatar.vue";
import { useDonationStore } from "@/store/donationStore";
import { formatAmount, formatDate } from "@/utils";
import CampaignModal from "@/views/pages/modals/CampaignModal.vue";
// store
const donationStore = useDonationStore();

// data
const filterBy = ref([
  { title: "Pending", key: "status", value: "Pending" },
  { title: "Completed", key: "status", value: "Completed" },
]);

const donations = reactive({
  filters: ["name"],
  columns: [
    {
      title: "S/N",
      key: "serial",
      dataIndex: "index",
    },
    {
      title: "User",
      key: "user",
      sorter: {
        compare: (a, b) => {
          a = a.user.name.toLowerCase();
          b = b.user.name.toLowerCase();
          return a > b ? -1 : b > a ? 1 : 0;
        },
      },
    },
    {
      title: "Amount",
      key: "amount",
      sorter: {
        compare: (a, b) => {
          a = a.amount.toLowerCase();
          b = b.amount.toLowerCase();
          return a > b ? -1 : b > a ? 1 : 0;
        },
      },
    },
    {
      title: "Source",
      key: "campaign",
    },
    {
      title: "Status",
      key: "status",
      sorter: {
        compare: (a, b) => {
          a = a.status.toLowerCase();
          b = b.status.toLowerCase();
          return a > b ? -1 : b > a ? 1 : 0;
        },
      },
    },
    {
      title: "Created At",
      key: "created_at",
      sorter: {
        compare: (a, b) => {
          a = new Date(a.created_at);
          b = new Date(b.created_at);
          return a > b ? -1 : b > a ? 1 : 0;
        },
      },
    },
  ],
  data: computed(() =>
    donationStore.donations.map((donation) => ({
      ...donation,
      name: donation.user.name,
    }))
  ),
});

const pageData = ref({ page: 1, pageSize: null });
// ref elements
const collapseHeader = ref(null);
const campaign = ref(null);
// Methods

function getBadgeClass(status) {
  return `badge badge-line${status == "Completed" ? "success" : "grey"}`;
}
function fetchDonations() {
  donationStore.fetchDonations();
}


function openModal(selectedCampaign)
{
  campaign.value = {
    ...selectedCampaign,

    media_item_url:
        selectedCampaign.media_item_url ||
        selectedCampaign.thumbnail?.url ||
        null,

  };

  $("#campaignModal").modal("show");
}


onMounted(async () => {
  if (donations.data.length <= 0) {
    fetchDonations();
  }
});
</script>

<style scoped>
.campaign-link {
  display: inline-flex;
  align-items: center;
  /* Center children vertically and horizontally */
  justify-content: center;
  gap: 6px;
  padding: 5px 10px;
  border-radius: 6px;
  color: #0d6efd;
  background: rgba(13, 110, 253, 0.08);
  font-size: 13px;
  font-weight: 500;
  line-height: 1;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.2s ease;
}

.campaign-link .feather-eye {
  width: 14px;
  height: 14px;
  /* Use flex positioning to keep it centered inside its slot */
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin: 0;
  vertical-align: middle;
}

/* Ensure any injected SVG scales cleanly to match the wrapper size */
.campaign-link .feather-eye svg {
  width: 100%;
  height: 100%;
}

.campaign-link .feather-eye:hover {
  color: #fff !important;

}

.campaign-link span {
  display: inline-block;
  line-height: 1; /* Reset line-height to align flush with flex */
}

.campaign-link:hover {
  color: #fff;
  background: #0d6efd;
  text-decoration: none;
}
</style>